import classNames from 'classnames';
import { getResponsiveClassNames, getResponsiveStyles, } from '@radix-ui/themes/dist/esm/helpers/get-responsive-styles.js';
import { isResponsiveObject } from '@radix-ui/themes/dist/esm/helpers/is-responsive-object.js';
import { mergeStyles } from '@radix-ui/themes/dist/esm/helpers/merge-styles.js';
function mergePropDefs(...args) {
    return Object.assign({}, ...args);
}
function extractProps(props, ...propDefs) {
    let className;
    let style;
    const extractedProps = { ...props };
    const allPropDefs = mergePropDefs(...propDefs);
    for (const key in allPropDefs) {
        let value = extractedProps[key];
        const propDef = allPropDefs[key];
        if (propDef.default !== undefined && value === undefined) {
            value = propDef.default;
        }
        if (propDef.type === 'enum') {
            const values = [propDef.default, ...propDef.values];
            if (!values.includes(value) && !isResponsiveObject(value)) {
                value = propDef.default;
            }
        }
        extractedProps[key] = value;
        if ('className' in propDef && propDef.className) {
            delete extractedProps[key];
            const isResponsivePropDef = 'responsive' in propDef;
            if (!value || (isResponsiveObject(value) && !isResponsivePropDef)) {
                continue;
            }
            if (isResponsiveObject(value)) {
                if (propDef.default !== undefined && value.initial === undefined) {
                    value.initial = propDef.default;
                }
                if (propDef.type === 'enum') {
                    const values = [propDef.default, ...propDef.values];
                    if (!values.includes(value.initial)) {
                        value.initial = propDef.default;
                    }
                }
            }
            if (propDef.type === 'enum') {
                const propClassName = getResponsiveClassNames({
                    allowArbitraryValues: false,
                    value,
                    className: propDef.className,
                    propValues: propDef.values,
                    parseValue: propDef.parseValue,
                });
                className = classNames(className, propClassName);
                continue;
            }
            if (propDef.type === 'string' || propDef.type === 'enum | string') {
                const propDefValues = propDef.type === 'string' ? [] : propDef.values;
                const [propClassNames, propCustomProperties] = getResponsiveStyles({
                    className: propDef.className,
                    customProperties: propDef.customProperties,
                    propValues: propDefValues,
                    parseValue: propDef.parseValue,
                    value,
                });
                style = mergeStyles(style, propCustomProperties);
                className = classNames(className, propClassNames);
                continue;
            }
            if (propDef.type === 'boolean' && value) {
                className = classNames(className, propDef.className);
                continue;
            }
        }
    }
    extractedProps.className = classNames(className, props.className);
    extractedProps.style = mergeStyles(style, props.style);
    return extractedProps;
}
export { extractProps };
//# sourceMappingURL=extract-props.js.map